<template>
  <div class="row custom-questions__wrapper">
    <question
        v-for="(question, index) in questions"
        :key="question.id"
        :is-active="isQuestionActive(index)"
        :test="test"
        :exam="exam"
        :type="type"
        :options="options"
        :is-last="isLastQuestion(index)"
        :question="question"
        @answer="setAnswer"
    />
  </div>
</template>

<script>

export default {

  props: {
    test     : {
      type    : Object,
      required: false,
    },
    exam     : {
      type    : Object,
      required: false,
    },
    questions: Array,
    index    : Number,
    type     : {
      type    : String,
      required: true,
      default : 'exam',
    },
    // Options/Config for the test
    // If no provided, we create the default here
    // it should be passed to the questions/question/Selfcontrol etc.
    options: {
      type    : Object,
      required: false,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {
        autoContinue: false,
      },
    },
  },
  emits: ['finished', 'indexChanged', 'selfcheck'],

  data() {
    return {
      isDebug       : false,
      allAnswered   : false,
      currentIndex  : null,
      answeredCount : 0,
      results       : null,
      addedQuestions: 0,
    }
  },

  mounted() {
    this.currentIndex = this.index
    this.answeredCount = this.index
  },

  methods: {
    isQuestionActive: function (index) {
      return (index === this.currentIndex)
    },

    isLastQuestion: function (index) {
      return this.questions.length - 1 === index
    },

    finish: function () {

    },

    /**
     * Checks after new answer if it was the last question and results where presenetd
     *
     * depending on emit results can contain only result data or even more like in the
     * case of selfcheck
     *
     * @param results
     */
    setAnswer: function (results) {

      this.isFirstQuestion = false
      this.answeredCount++
      this.currentScore = 0
      this.currentIndex++
      this.$emit('indexChanged', this.currentIndex)


      // If we have the answer in the results, we want to add it to the test state
      if (results && results.answer) {
        this.maybeAddAnswerToTest(results.answer);
      }

      this.allAnswered = this.areAllQuestionsAnswered()

      // If all questions are not answered and there
      if (this.answeredCount === this.questions.length && !this.allAnswered) {
        this.maybeAppendUnansweredQuestions();
      }

      if (this.allAnswered && results) {
        if (results.selfcheck) {
          this.$emit('selfcheck', results)
        } else if ('practice' === this.type || 'mistakes' === this.type || results.results) {
          this.$emit('finished', results)
        }
      }
    },

    /**
     * Adds an answer to the appropriate test if the answer to a question is not already there.
     * @param answer
     */
    maybeAddAnswerToTest: function (answer) {
      if (!this.test) {
        return;
      }

      let alreadyAnswered = false;
      for (let i = 0; i < this.test.answers.length; i++) {
        if (this.test.answers[i].id === answer.id) {
          alreadyAnswered = true;
          break;
        }
      }

      if (!alreadyAnswered) {
        this.test.answers.push(answer);
      }
    },

    /**
     * Determines if all questions of a test/practice are answered.
     *
     * @returns {boolean}
     */
    areAllQuestionsAnswered: function () {
      if ('practice' === this.type || 'mistakes' === this.type) {
        return this.allAnswered = this.answeredCount === this.questions.length
      }

      return (this.test.answers.length + this.addedQuestions) === this.questions.length
    },

    /**
     * Appends the unanswered questions to the end of the questions array
     */
    maybeAppendUnansweredQuestions: function () {
      let _self = this;
      // TODO: Find the unanswered questions and append them to the end of the this.questions, so we can display them next.
      let answeredQuestionsIds = this.test.answers.map((answer, index) => {
        return answer.question_id;
      });

      let questionsIds = this.questions.map((question, index) => {
        return question.id;
      });

      let unansweredQuestions = questionsIds.filter(x => !answeredQuestionsIds.includes(x));

      let addQuestions = unansweredQuestions.map((id) => {
        return _self.getQuestionById(id)
      });

      // Add the questions to the end
      addQuestions.map((question) => {
        this.questions.push(question[0]);
      });

      this.addedQuestions = addQuestions.length;
    },

    /**
     * Finds the question by its ID
     * @param id
     * @returns {*[]}
     */
    getQuestionById: function (id) {
      let foundQuestions = this.questions.filter((question) => question.id === id)

      // Remove duplicates
      return foundQuestions.filter((element, index) => foundQuestions.indexOf(element) === index);
    },
  },
}
</script>

<style scoped>
.feedback__starter {
  display: none !important;
}
</style>
